export const EDUCATION_QUALIFICATIONS = [
  "High School",
  "Bachelor's Degree",
  "Master's Degree",
  "Post Graduate Diplomaa",
  "Doctorate"
]

export const STUDY_LEVELS = [
  "Undergraduate",
  "Postgraduate",
  "Doctorate"
]

export const PREFERRED_COUNTRIES = [
  "United States",
  "United Kingdom",
  "Canada",
  "Australia",
  // "Germany",
  // "France",
  "Ireland",
  "New Zealand"



]

export const FIELDS_OF_STUDY = [
  "Art and Design",
  "Agriculture Sciences",
  "Accounting",
  "Biological and Life Sciences",
  "Building and Architecture",
  "Business",
  "Chemistry",
  "Computer Science",
  "Economics",
  "Engineering",
  "Environmental Science",
  "Finance",
  "Fashion and Textiles",
  "Health and Medicine",
  "Geography",
  "History",
  "Human Welfare Studies And Services",
  "Hospitality and Tourism",
  "Information Science and Librarianship",
  "Language and Culture",
  "Law and Legal Studies",
  "Management",
  "Marketing, Media and Communication",
  "Mechanic and Repair Technologies",
  "Military",
  "Multidisciplinary Studies",
  "Others",
  "Pharmacy",
  "Performing Arts and Music",
  "Physics",
  "Psychology",
  "Political and Social Sciences",
  "Teaching and Education",
  "All",
]

